export const routeConstants = {
  tileAssetAtlasImage: "/tileAssetAtlasImage",
  tileThumbnails: "/tileThumbnails",
  atlasTileSourceImages: (tileAssetId, usage, version) => `/api/resources/tileAssetImage/${encodeURIComponent(tileAssetId)}/${usage}/${version}`
};
export function getThumbnailUrl(filename) {
  if (!filename) return null;
  return routeConstants.tileThumbnails + "/" + filename;
}